import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import { ILandmarkCoordinate } from "../../../../../../../@types/customerLegScan.types";
import { displayValue } from "../../../../../../../utils/commonFunctions/displayValue";

const LandmarkTable = ({ side, points }: { side: string; points: Record<string, ILandmarkCoordinate> }) => {
	const entries = Object.entries(points);
	if (entries.length === 0) return null;

	return (
		<TableContainer style={{ marginBottom: "1rem" }}>
			<h4 style={{ color: "#003545", margin: "0 0 0.5rem 0" }}>{side}</h4>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Point</TableCell>
						<TableCell align="center">X</TableCell>
						<TableCell align="center">Y</TableCell>
						<TableCell align="center">Z</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{entries.map(([point, coords]) => (
						<TableRow key={point}>
							<TableCell>{point}</TableCell>
							<TableCell align="center">{displayValue(coords?.x)}</TableCell>
							<TableCell align="center">{displayValue(coords?.y)}</TableCell>
							<TableCell align="center">{displayValue(coords?.z)}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const ScanLandmarkCoordinates = ({ legScan }: ILegScanProps) => {
	const hasLeft = Object.keys(legScan.landmark_coordinates_left || {}).length > 0;
	const hasRight = Object.keys(legScan.landmark_coordinates_right || {}).length > 0;

	if (!hasLeft && !hasRight) return null;

	return (
		<Accordion>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<span style={{ color: "#003545", fontWeight: 600 }}>Landmark Coordinates</span>
			</AccordionSummary>
			<AccordionDetails style={{ display: "flex", flexWrap: "wrap", gap: "2rem", width: "100%" }}>
				{hasLeft ? (
					<div style={{ flex: "1 1 320px" }}>
						<LandmarkTable side="Left" points={legScan.landmark_coordinates_left || {}} />
					</div>
				) : null}
				{hasRight ? (
					<div style={{ flex: "1 1 320px" }}>
						<LandmarkTable side="Right" points={legScan.landmark_coordinates_right || {}} />
					</div>
				) : null}
			</AccordionDetails>
		</Accordion>
	);
};

export default ScanLandmarkCoordinates;
